import * as React from "react";
import {
	Form,
	FormGroup,
	ControlLabel,
	FormControl,
	HelpBlock,
	Schema,
	Button,
	ButtonToolbar,
} from "rsuite";
import styled from "styled-components";
import { Config, DesignSystem as DS, Endpoints } from "configs/index";
import { Notification } from "commons/Notification";
import Axios from "axios";

const { StringType } = Schema.Types;

const model = Schema.Model({
	email: StringType()
		.isEmail("Please enter a valid email address.")
		.isRequired("This field is required."),
});

const StyledButton = styled(Button).attrs((props) => ({
	fill: props.fill ? props.fill : DS.colors.primary,
	className: "mt-2",
}))`
	background: ${(props) => props.fill}!important;

	&:hover,
	&:active,
	&:focus,
	&:visited,
	&:focus-visible,
	&:active:focus {
		background: ${(props) => props.fill}!important;
	}
`;

interface IProps {
	setEmail: any;
}

export default class Recover extends React.Component<IProps, any> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			spinner: false,
			formValue: {
				email: "",
			},
		};
	}
	getRequest(
		pathRelative: string,
		data: any,
		success?: any,
		error?: any,
		always?: any
	) {
		const CancelToken = Axios.CancelToken;
		const source = CancelToken.source();

		Axios.get(Config.END_POINT + pathRelative, {
			params: data,
			cancelToken: source.token,
		})
			.then(function (response) {
				if (success) {
					success(response);
				}
			})
			.catch(function (errors) {
				if (errors.response && error) {
					error(errors);
				}
			})
			.then(function () {
				if (always) {
					always();
				}
			});

		return source;
	}

	handleSubmit() {
		const { formValue } = this.state;

		this.setState(
			(prevState: any) => ({
				spinner: true,
				formValue: { ...prevState.formValue },
			}),
			() => {
				//console.log(this.state);
				let data: any = {
					email: formValue.email,
				};
				this.setState({ spinner: true });
				this.getRequest(
					Endpoints.GET_FORGOT_PASSWORD,
					data,
					this.success,
					this.error,
					this.always
				);
			}
		);
	}

	success = (response: any) => {
		const { setEmail } = this.props;
		//console.log("response:", response);
		//console.log(setEmail);
		setEmail();
	};

	error = (error: any) => {
		Notification.errorObject(error);
	};

	always = () => {
		this.setState({
			spinner: false,
			formValue: {
				email: "",
			},
		});
	};

	render() {
		const { formValue, spinner } = this.state;
		return (
			<>
				<p className="mt-4">
					Por favor ingrese su dirección de correo para recuperar su contraseña
				</p>
				<Form
					model={model}
					fluid
					className="custom-form rs-form-group-m-b-10"
					onChange={(formValue) => {
						this.setState({ formValue });
					}}
					onSubmit={(check_status: boolean) =>
						check_status ? this.handleSubmit() : false
					}
					formValue={formValue}
				>
					<FormGroup className="required mt-4">
						<ControlLabel className="text-uppercase">Correo</ControlLabel>
						<FormControl name="email" type="email" />
						<HelpBlock className="d-none">Required</HelpBlock>
					</FormGroup>
					<div className="d-flex justify-content-between align-items-center">
						<a href={Config.BASE_URL}>Volver al login</a>
						<ButtonToolbar className="d-flex justify-content-end">
							<StyledButton
								appearance="primary"
								type="submit"
								loading={spinner}
							>
								Recuperar contraseña
							</StyledButton>
						</ButtonToolbar>
					</div>
				</Form>
			</>
		);
	}
}
